module.exports = __webpack_public_path__ + "static/img/2_6.ebc51712.jpg";